




























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

import CreateBrandMonitoringPopup from '@/components/Monitoring/CreateBrandMonitoringPopup.vue';
import { Brand, BrandIndexItem, BrandQueryResultItem } from '@/api/braendz';

@Component({
    components: {
        CreateBrandMonitoringPopup
    }
})
export default class MonitorBrandButton extends Vue {
    // Data
    public showPopup = false;

    // Properties
    @Prop({ required: true })
    public type!: 'icon' | 'list-item';

    @Prop({required: true})
    public brand!: BrandQueryResultItem | BrandIndexItem | Brand | null | undefined;
}
